"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notNull = notNull;
exports.getDataByName = getDataByName;
exports.setDataByObj = setDataByObj;
exports.setDataByName = setDataByName;
exports.parseStyleText = parseStyleText;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _lodash = _interopRequireDefault(require("lodash"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function notNull(obj) {
  return obj !== undefined && obj !== null;
}
/**
 * 根据 'name.name' 的字符串 获取对象对于位置的值
 * @param data
 * @param name
 */


function getDataByName(data, name) {
  var currentData = data;
  var keys = name.trim().split('.');
  keys.forEach(function (key) {
    var index = key.indexOf('[');
    var lastIndex = key.indexOf(']');

    if (!currentData) {
      return;
    }

    while (index !== -1 && lastIndex !== -1) {
      if (index !== 0) {
        currentData = currentData[key.substring(0, index)];
      }

      if (!currentData) {
        return;
      }

      currentData = currentData[key.substring(index + 1, lastIndex)];
      key = key.substring(lastIndex + 1);
      index = key.indexOf('[');
      lastIndex = key.indexOf(']');
    }

    if (!currentData) {
      return;
    }

    if (key) {
      currentData = currentData[key];
    }
  });
  return currentData;
}
/**
 * { ['name.name']: value } 把名称的值插入到制定位置
 * @param data
 * @param obj
 */


function setDataByObj(data, obj) {
  var out = data;

  if (!out) {
    return out;
  }

  var isArray = Array.isArray(out);
  Object.keys(obj).forEach(function (key) {
    if (isArray) {
      var index = key.indexOf('[');
      var lastIndex = key.indexOf(']');
      var num = key.substring(index + 1, lastIndex).trim();
      out[num] = setDataByObj(out[num], (0, _defineProperty2.default)({}, key.substring(lastIndex + 1), obj[key]));
    } else {
      out = setDataByName(out, key, obj[key]);
    }
  });
  return out;
}

function setDataByName(initData, name, data) {
  var out = _objectSpread({}, initData);

  var tempKeys = name.trim().split('.');
  var keys = tempKeys.map(function (k) {
    var list = [];
    var key = k.trim();
    var index = key.indexOf('[');
    var lastIndex = key.indexOf(']'); // 把所有层级转化成 name 的数组

    while (index !== -1 && lastIndex !== -1) {
      if (index !== 0) {
        list.push(key.substring(0, index).trim());
      }

      list.push(key.substring(index + 1, lastIndex).trim());
      key = key.substring(lastIndex + 1);
      index = key.indexOf('[');
      lastIndex = key.indexOf(']');
    }

    if (key) {
      list.push(key);
    }

    return list;
  });
  keys = _lodash.default.flatten(keys);
  var reg = /^[0-9]+.?[0-9]*$/;
  var currentValue = out;
  keys.forEach(function (key, i) {
    if (i === keys.length - 1) {
      currentValue[key] = data;
      return;
    }

    if (!currentValue[key]) {
      if (reg.test(keys[i + 1])) {
        currentValue[key] = [];
      } else {
        currentValue[key] = {};
      }
    }

    currentValue = currentValue[key];
  });
  return out;
}

var camelizeRE = /-(\w)/g;

var camelize = function camelize(str) {
  return str.replace(camelizeRE, function (_, c) {
    return c ? c.toUpperCase() : '';
  });
};

function parseStyleText() {
  var cssText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var camel = arguments.length > 1 ? arguments[1] : undefined;
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);

      if (tmp.length > 1) {
        var k = camel ? camelize(tmp[0].trim()) : tmp[0].trim();
        res[k] = tmp[1].trim();
      }
    }
  });
  return res;
}